export const INFO = 'info';
export const DEBUG = 'debug';
export const ERROR = 'error';
export const WARN = 'warn';
